module.exports = __webpack_public_path__ + "img/password-reset.8d2c96ab.svg";